module.exports = __webpack_public_path__ + "img/about-bottom-img.bd0a8424.jpg";